/**
 * Universal Image URL Helper for Frontend
 * Handles all legacy uploads, CMS images (sliders, blogs, testimonials), and new R2 keys.
 */
const sanitizeUrl = (url) => {
  if (!url || typeof url !== "string") return "";
  try {
    const parsed = new URL(url);
    parsed.pathname = parsed.pathname.replace(/\/+/g, "/");
    return parsed.toString();
  } catch (e) {
    return url.replace(/([^:])\/+/g, "$1/");
  }
};

export const getImageUrl = (imagePath, defaultImg = "/assets/img/register/image-picture_svgrepo.com.png") => {
  if (!imagePath || typeof imagePath !== "string") {
    return defaultImg;
  }

  const cleanPath = imagePath.trim();

  // 1. Data URLs
  if (cleanPath.startsWith("data:")) {
    return cleanPath;
  }

  // 2. Full HTTP/HTTPS URLs (clean up any duplicate slashes like vivashri//uploads)
  if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
    return sanitizeUrl(cleanPath);
  }

  const cdnBase = (
    process.env.REACT_APP_CDN_BASE_URL ||
    "https://cdn.vivashri.org"
  ).replace(/\/+$/, "");

  // Remove any leading slashes
  const normalizedKey = cleanPath.replace(/^\/+/, "");

  // If already prefixed with vivashri/
  if (normalizedKey.startsWith("vivashri/")) {
    return sanitizeUrl(`${cdnBase}/${normalizedKey}`);
  }

  // If path starts with public/uploads/ -> convert to uploads/
  if (normalizedKey.startsWith("public/uploads/")) {
    return sanitizeUrl(`${cdnBase}/vivashri/${normalizedKey.replace(/^public\//, "")}`);
  }

  // If path already starts with uploads/
  if (normalizedKey.startsWith("uploads/")) {
    return sanitizeUrl(`${cdnBase}/vivashri/${normalizedKey}`);
  }

  // Default: treat as file in uploads/
  return sanitizeUrl(`${cdnBase}/vivashri/uploads/${normalizedKey}`);
};
